export default {
  title: 'Blacklist Management',
  tip: 'Members on the blacklist cannot participate in any member activities. Manage blacklisted members here.',
  columns: {
    id: 'ID',
    nickname: 'Nickname',
    level: 'Level',
    country: 'Country',
    email: 'Email',
    phone: 'Phone',
    wechat: 'WeChat',
    registerTime: 'Register Time',
  },
  actions: {
    remove: 'Remove from Blacklist',
  },
  removeConfirm: {
    title: 'Are you sure to remove this user from the blacklist?',
    tip: 'After removal, this user will participate in all activities normally.',
  },
};
